import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipWrapper = ({ children, id, text, position }: {
    children: React.ReactNode;
    id: string;
    text: any;
    position?: string;
}) => {
    return (
        <OverlayTrigger
            key={id}
            placement={'top'}
            overlay={
                <Tooltip id={`tooltip-top` + id} style={{ position: "fixed" }}>
                    {text}
                </Tooltip>
            }
        >
            <span style={{ cursor: 'pointer', width: 'fit-content', position: position as any}}>
                {children}
            </span>

        </OverlayTrigger>
    );
};

export default TooltipWrapper;
